import React from "react";
import "../PrivacyPage/PrivacyPage.css";
import { Container } from "react-bootstrap";
import { useLanguage } from "../../Context/LanguageContext";

const TandC = () => {
  const { language } = useLanguage();
  return (
    <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
      <section className="privacy-policy-section">
        {language === "en" ? (
          <div className="privacy-policy">
            <div className="policy-description">
              <div className="privacy-heading">JK SEL Terms Of Use</div>
              <div className="privacy-description">
                <li>
                  JK SEL Co., Ltd / JK SEL INDIA Pvt. Ltd. (collectively “JK
                  SEL” or “we”) is a global software development and services
                  company. These terms and conditions of use (“Terms”) apply to
                  your use of our Website (“Website”).
                </li>
                {/* <br /> */}
                <li>
                  JK SEL does not guarantee the accuracy of any information
                  provided on this Website. We reserve the right to make changes
                  and alterations as necessary. When we make these changes, we
                  will post the updated Terms, date of effectiveness, and other
                  information on our Website. We will also contact interested
                  third parties to inform them of these changes.
                </li>
                {/* <br /> */}
                <li>
                  JK SEL will not notify you directly regarding these
                  alterations. To stay current on our Terms, we advise you to
                  check regularly for updates to our Terms and Conditions. For
                  more information about our privacy policy and Terms of Use,
                  please contact us at any time.
                </li>
              </div>
              <div className="privacy-title">Disclaimer of Warranty</div>
              <div className="privacy-description">
                <li>
                  We provide all materials “AS IS” without express or implied
                  warranty. JK SEL disclaims warranties of any kind, whether
                  expressly implied or statutory, including claims about
                  usefulness, suitability for any purpose, security and
                  non-infringement, and all warranties regarding the
                  availability of the information we provide. We disclaim all
                  warranties related to the accuracy of our content.
                </li>
                {/* <br /> */}
                <li>
                  JK SEL does not guarantee that the Website’s features,
                  functions, or content are secure, accurate, free of errors, or
                  free of defects. We will not be responsible for functional
                  failures of the Website, errors, malfunctions, site crashes,
                  loss of data, or other events that occur after your use of our
                  Website. We do not guarantee that the Website will be
                  corrected or updated at any time or in response to any
                  request.
                </li>
                {/* <br /> */}
                <li>
                  We disclaim all responsibility for the risk, damage to your
                  computer system, loss of personal data, inaccuracy of content,
                  or other events associated with the use of our Website. You
                  agree to use this Website at your sole risk and discretion,
                  and you assume all responsibility for your use. If you are
                  uncertain about the risks associated with using this Website,
                  we encourage you to stop using this Website.
                </li>
              </div>
              <div className="privacy-title">Limitation of Liability</div>
              <div className="privacy-description">
                <li>
                  JK SEL will not be liable for any damages, indirect or
                  consequential, arising from your use of this Website. We
                  disclaim any and all liability incurred by this use, including
                  loss of profits, cost of replacement, damages caused by the
                  improper release of information, actions taken based on
                  inaccurate information or any other liabilities. We expressly
                  disclaim this liability, even in cases where we were informed
                  of the possibility of damages.
                </li>
              </div>
              <div className="privacy-title">User Agreement</div>
              <div className="privacy-description">
                While using the Website, you agree not to:
                <br />
                <br />
                <li>
                  Upload or post any information on our Website that violates
                  the Terms or the Policy.
                </li>
                {/* <br /> */}
                <li>
                  Restrict the free use of this Website by any person, conduct
                  yourself in a way that encourages the unlawful use of this
                  Website, or use this Website in any way that could result in a
                  criminal or civil charge.
                </li>
                {/* <br /> */}
                <li>
                  Post, upload or publish any information you find on this
                  Website in any manner that is not authorized by JK SEL, for
                  private commercial uses, for the purposes of spamming or
                  flooding, or for gaining unlawful access to a third party or
                  affiliated entity.
                </li>
                {/* <br /> */}
                <li>
                  Use information gathered on this Website to gain unauthorized
                  or unlawful access to any corporate or government entity, get
                  unlawful access to personal information, or make other
                  attempts at fraudulent activity.
                </li>
                {/* <br /> */}
                <li>
                  JK SEL has the right to regularly monitor the Website. This
                  includes our ongoing efforts to preserve the security of
                  private personal and corporate information retained on this
                  Website. We retain the right to disclose any information we
                  have gathered when necessary to comply with criminal
                  investigations, government examinations, judicial subpoenas,
                  fraud investigations or financial audits. JK SEL does not make
                  any express or implied guarantee that we will update or
                  monitor this Website.
                </li>
                {/* <br /> */}
              </div>
              {/* <br /> */}
              <div className="privacy-title">Use of Content</div>
              <div className="privacy-description">
                <li>
                  You may use the information, images, videos, software,
                  scripting, text, graphics, music, sounds and other materials
                  on this Website (collectively “Content”) for informational,
                  non-commercial and personal use only. You may not modify,
                  alter, delete or publish the Content without our express
                  written permission.
                </li>
                {/* <br /> */}
                <li>
                  Your use implies your agreement to observe all copyright and
                  other proprietary notices contained in the materials. You may
                  not use the Content for commercial uses without the express
                  written consent of JK SEL. You are prohibited from the
                  unauthorized copying, displaying, or other use of any Content
                  from this Website. The unauthorized use of our Content is
                  unlawful, and we will pursue this violation to the full extent
                  of local, state, and international law.
                </li>
                {/* <br /> */}
                <li>
                  We do not require permission to link to JK SEL from other
                  sites, but we appreciate notification of the link.
                </li>
              </div>
              <div className="privacy-title">Copyright and Trademarks</div>
              <div className="privacy-description">
                <li>
                  All product and brand names are copyrights or registered
                  trademarks of their respective holders. We provide our
                  copyright images for your information only. This availability
                  on our Website does not grant you a license to use it. JK SEL
                  holds the copyright on all material we create for the Website.
                  We also display Content that is the copyrighted material of
                  its original creator. Use of this Website does not constitute
                  a right to use our intellectual property or copyrighted
                  material. JK SEL and the Content creators retain full and
                  complete rights to all material.
                </li>
              </div>
              <div className="privacy-title">Applicable Laws</div>
              <div className="privacy-description">
                <li>
                  We do not imply that access to this Website constitutes legal
                  permission to use it in places where such use is illegal. All
                  users agree to use the Website at their own risk and take
                  responsibility for all consequences. All users of this Website
                  must comply with applicable local and international laws.
                </li>
              </div>
              <div className="privacy-title">Contact Us</div>
              <div className="privacy-description">
                <li>
                  If you have questions about this Privacy Policy or our Terms
                  of Use, please contact us at info@jkselab.com.
                </li>
              </div>
            </div>
          </div>
        ) : (
          <div className="privacy-policy">
            <div className="policy-description">
              <div className="privacy-heading">JK셀 이용약관</div>
              <div className="privacy-description">
                <li>
                  JK SEL Co., Ltd / JK SEL INDIA Pvt. Ltd. (이하 “JK셀” 또는
                  “우리”)는 글로벌 소프트웨어 개발 및 서비스 회사입니다. 본 이용
                  약관(이하 “약관”)은 귀하가 우리의 웹사이트(이하 “웹사이트”)를
                  이용하는 데 적용됩니다.
                </li>
                {/* <br /> */}
                <li>
                  JK셀은 이 웹사이트에서 제공되는 정보의 정확성을 보장하지
                  않습니다. 우리는 필요에 따라 변경 및 수정을 할 권리를
                  보유합니다. 이러한 변경을 할 경우, 업데이트된 약관, 효력
                  발생일 및 기타 정보를 웹사이트에 게시할 것입니다. 또한, 관련된
                  제3자에게 이러한 변경 사항을 알리기 위해 연락할 것입니다.
                </li>
                {/* <br /> */}
                <li>
                  JK셀은 이러한 변경 사항에 대해 귀하에게 직접 알리지 않습니다.
                  최신 약관을 유지하려면, 약관과 조건에 대한 업데이트를
                  정기적으로 확인할 것을 권장합니다. 개인정보 보호정책 및 이용
                  약관에 대한 추가 정보가 필요하시면 언제든지 저희에게 연락해
                  주세요.
                </li>
              </div>
              <div className="privacy-title">면책 조항</div>
              <div className="privacy-description">
                <li>
                  우리는 모든 자료를 "있는 그대로" 제공하며, 명시적이거나
                  묵시적인 보증을 하지 않습니다. JK셀은 유용성, 특정 목적에의
                  적합성, 보안, 비침해성 및 우리가 제공하는 정보의 가용성에 관한
                  보증을 포함하여, 모든 종류의 보증을 부인합니다. 우리는
                  콘텐츠의 정확성에 관한 모든 보증을 부인합니다.
                </li>
                {/* <br /> */}
                <li>
                  JK 셀은 웹사이트의 기능, 기능성 또는 콘텐츠가 안전하고
                  정확하며 오류나 결함이 없다고 보장하지 않습니다. 우리는
                  웹사이트의 기능 실패, 오류, 오작동, 사이트 충돌, 데이터 손실
                  또는 웹사이트 사용 후 발생하는 기타 사건에 대해 책임지지
                  않습니다. 또한, 웹사이트가 언제든지 수정되거나 업데이트될
                  것이라고 보장하지 않으며, 어떤 요청에도 반응하여 수정되지 않을
                  수 있습니다
                </li>
                {/* <br /> */}
                <li>
                  우리는 웹사이트 사용과 관련된 컴퓨터 시스템의 위험, 손상,
                  개인정보 손실, 콘텐츠의 부정확성 또는 기타 사건에 대해 모든
                  책임을 부인합니다. 귀하는 본 웹사이트를 자신의 책임 하에
                  이용하며, 모든 책임을 지고 사용합니다. 웹사이트 사용과 관련된
                  위험에 대해 확신이 없다면, 웹사이트 사용을 중단할 것을
                  권장합니다.
                </li>
              </div>
              <div className="privacy-title">책임 제한</div>
              <div className="privacy-description">
                <li>
                  JK셀은 귀하가 이 웹사이트를 사용함으로 인해 발생하는 모든
                  간접적이거나 결과적인 손해에 대해 책임지지 않습니다. 우리는 이
                  사용으로 인해 발생한 모든 책임을 부인합니다. 여기에는 이익
                  손실, 교체 비용, 부적절한 정보 공개로 인한 손해, 부정확한
                  정보를 바탕으로 취한 조치 또는 기타 모든 책임이 포함됩니다.
                  우리는 손해 가능성에 대해 통지를 받은 경우에도 이 책임을
                  명시적으로 부인합니다.
                </li>
              </div>
              <div className="privacy-title">사용자 동의</div>
              <div className="privacy-description">
                웹사이트를 사용하면서, 귀하는 다음 사항을 하지 않기로
                동의합니다:
                <br />
                <br />
                <li>
                  웹사이트에 본 약관이나 정책을 위반하는 정보를 업로드하거나
                  게시하는 행위.
                </li>
                {/* <br /> */}
                <li>
                  이 웹사이트의 자유로운 사용을 제한하거나, 웹사이트의 불법적인
                  사용을 유도하는 행동을 하거나, 범죄 또는 민사상 혐의를 초래할
                  수 있는 방식으로 이 웹사이트를 사용하는 행위.
                </li>
                {/* <br /> */}
                <li>
                  이 웹사이트에서 찾은 정보를 JK셀의 허가 없이 사적 상업적 용도,
                  스팸이나 플러딩 목적, 또는 제3자나 관련 기관에 불법적으로
                  접근하기 위한 방법으로 게시, 업로드 또는 공개하는 행위.
                </li>
                {/* <br /> */}
                <li>
                  이 웹사이트에서 수집한 정보를 사용하여 기업 또는 정부 기관에
                  무단 또는 불법적으로 접근하거나, 개인 정보를 불법적으로
                  접근하거나, 다른 사기 활동을 시도하는 행위.
                </li>
                {/* <br /> */}
                <li>
                  JK셀은 웹사이트를 정기적으로 모니터링할 권리를 가지고
                  있습니다. 이는 웹사이트에 저장된 개인 및 기업 정보의 보안을
                  유지하려는 지속적인 노력에 포함됩니다. 우리는 범죄 조사, 정부
                  조사, 사법적 소환장, 사기 조사 또는 재무 감사에 따라 필요한
                  경우 수집한 정보를 공개할 권리를 보유합니다. JK셀은 이
                  웹사이트를 업데이트하거나 모니터링할 것이라는 명시적 또는
                  암시적 보장을 하지 않습니다.
                </li>
                {/* <br /> */}
              </div>
              {/* <br /> */}
              <div className="privacy-title">콘텐츠 사용</div>
              <div className="privacy-description">
                <li>
                  귀하는 이 웹사이트의 정보, 이미지, 비디오, 소프트웨어,
                  스크립트, 텍스트, 그래픽, 음악, 소리 및 기타 자료(통칭
                  '콘텐츠')를 정보 제공, 비상업적 및 개인적 용도로만 사용할 수
                  있습니다. 귀하는 우리의 명시적인 서면 허가 없이 콘텐츠를 수정,
                  변경, 삭제하거나 게시할 수 없습니다.
                </li>
                {/* <br /> */}
                <li>
                  귀하의 사용은 자료에 포함된 모든 저작권 및 기타 소유권 고지를
                  준수하는 것에 동의하는 것으로 간주됩니다. JK셀의 명시적인 서면
                  동의 없이 콘텐츠를 상업적 용도로 사용할 수 없습니다. 이
                  웹사이트에서 콘텐츠를 무단으로 복사, 전시하거나 기타 용도로
                  사용하는 것은 금지됩니다. 무단 사용은 불법이며, 우리는 이를
                  지역 법률, 주 법률 및 국제 법률에 따라 전면적으로 추적하고
                  처벌할 것입니다.
                </li>
                {/* <br /> */}
                <li>
                  다른 사이트에서 JK셀로 링크하는 데에는 허가가 필요하지 않지만,
                  링크에 대한 알림을 감사히 받겠습니다.
                </li>
              </div>
              <div className="privacy-title">저작권 및 상표</div>
              <div className="privacy-description">
                <li>
                  모든 제품 및 브랜드 이름은 해당 소유자의 저작권 또는 등록
                  상표입니다. 우리는 귀하에게 정보를 제공하기 위해 저작권
                  이미지만 제공합니다. 이 이미지의 웹사이트에서의 제공은
                  귀하에게 사용 권한을 부여하지 않습니다. JK셀은 웹사이트를 위해
                  우리가 만든 모든 자료에 대한 저작권을 보유하고 있습니다. 또한
                  우리는 원래 창작자의 저작권이 있는 콘텐츠를 전시합니다. 이
                  웹사이트의 사용은 우리의 지적 재산권이나 저작권이 있는 자료를
                  사용할 권리를 구성하지 않습니다. JK셀과 콘텐츠 창작자는 모든
                  자료에 대해 완전하고 완전한 권리를 보유합니다.
                </li>
              </div>
              <div className="privacy-title">적용 법률</div>
              <div className="privacy-description">
                <li>
                  우리는 이 웹사이트에 대한 접근이 불법인 장소에서 사용을
                  허가하는 법적 의미를 갖는다고 암시하지 않습니다. 모든 사용자는
                  이 웹사이트를 자신의 책임 하에 사용하며 모든 결과에 대한
                  책임을 집니다. 이 웹사이트의 모든 사용자는 해당 지역 및
                  국제법을 준수해야 합니다.
                </li>
              </div>
              <div className="privacy-title">문의사항</div>
              <div className="privacy-description">
                <li>
                  이 개인정보 보호정책이나 이용약관에 대한 질문이 있는 경우,
                  info@jkselab.com으로 문의해 주세요.
                </li>
              </div>
            </div>
          </div>
        )}
      </section>
    </Container>
  );
};

export default TandC;
